import CollectionUtil from '../queries/lightbox/CollectionUtil';
import { isMobile } from '../util/ScreenUtil';

export default function initVariables() {
  // gs - global state. It is used instead of state managers like flux or redux.
  // Just change a variable in gs and call render, it is the simplest and consequently the best approach (the fewer variable the better).
  // Since global state is the most important object in the app document every variable which you create on it
  window.gs = {
    // All the authentication data is stored inside of Authenticator abstraction, so there is only a boolean
    isLogged: false,
    isReviewServerLogged: false,
    categoryList: null, // List of filter for AssetsTab
    assets: null, // List of assets for AssetsTab
    totatAssets: 0,
    activities: null, // List of activities for HomeTab
    blockSearch: false,
    collectionTabSortCriteria: CollectionUtil.SORT_PARAMS.DEFAULT_SORT_CRITERIA, //Sorting on CollectionTab
    collectionTabSortOrder: CollectionUtil.SORT_PARAMS.DEFAULT_SORT_ORDER, // Soring on AssetsTab
    assetTabSortCriteria: 'MODIFICATION_TIME',
    assetTabSortOrder: CollectionUtil.ASSET_SORT_PARAMS.DEFAULT_SORT_ORDER,
    collectionAssetsTabDefaultSortCriteria: CollectionUtil.ASSET_SORT_PARAMS.DEFAULT_SORT_CRITERIA, //Sorting on CollectionAssets
    collectionAssetsTabDefaultSortOrder: CollectionUtil.ASSET_SORT_PARAMS.DEFAULT_SORT_ORDER,
    collectionAssetsTabSortSettings: [],
    collectionAssetsTabSortOrder: [],
    //Selected assets on AssetsTab
    // It should be in global state because they should preserved when user switch tabs back and forth
    selectedAssets: [],
    // Map of available additional props which can be displayed on assets on AssetsTab
    // It is requested from the server.
    propName2PropInfoMap: null,
    // List of selected values from 'window.gs.propName2PropInfoMap'
    // They should be preserved on page reload
    groupCode2GroupInfoMap: null,
    viewProps: [],
    fuid2FavItemDetailMap: undefined,
    activityInfo: {},
    notificationInfo: {},
    collectionUnreadCountEntries: [],
    filterNames: null,
    editableMetadataProps: null,
    argsProcessed: false,
    companyName: undefined,
    companyTagLine: undefined,
    globalMetadataRestrictPattern: undefined,
    error: null, // In order to display an error set some string to "error" and rerender the app.
    infoMsg: undefined,
    issueSearchString: undefined,
    /**
     * @type {Array.<ZmCollection>}
     */
    collections: [],
    collectionsCount: 0,
    // Filters for Collection tab
    filterCollectionsList: null,
    globalLogoutURL: null,

    draggingFileInCollection: 0,
    /**
     * Some components want full control over the DnD operation. This flag is checked in LoggedBlock
     * to see if it should ignore the events.
     */
    ignoreGlobalDragDrop: false,
    /**
     * In this object, we will store link sharing data. Like link params, collection id.
     * @type {LinkSharingProperties}
     */
    linkSharingData: null,
    selectedCollectionFilterCounts: 0,

    bottomLeftTip: undefined, //See ViewUtil.showBottomLeftTip().. method.
    version: undefined,
    unreadCommentCount: 0,
    serverRealm: null,
    topBarHeight: isMobile() ? 50 : 70,
    video: {
      width: 0,
      height: 0,
      frameRate: 0
    },
    addAssetsForm: false,
    setProgress: _.noop
  };
  //
  //window.gs.showUploadingsPopover = false;
}
